/* POSH — تسريع الشراء في صفحة المنتج */
(function () {
  'use strict';

  var T = {
    buy: 'اشترِ الآن',
    buying: 'لحظة...',
    trust: [
      { icon: 'truck', text: 'شحن مجاني فوق 40 د.ك' },
      { icon: 'shield', text: 'إرجاع خلال 14 يوم' },
      { icon: 'bolt', text: 'شحن خلال 24 ساعة' }
    ]
  };

  var ICONS = {
    truck: '<path d="M3 7h11v8H3zM14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/>',
    shield: '<path d="M12 3l7 3v5c0 4-3 7-7 8-4-1-7-4-7-8V6z"/><path d="M9 12l2 2 4-4"/>',
    bolt: '<path d="M13 3L5 13h5l-1 8 8-10h-5z"/>'
  };

  function icon(name) {
    return '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + (ICONS[name] || '') + '</svg>';
  }

  function injectCss() {
    if (document.getElementById('posh-buynow-css')) return;
    var s = document.createElement('style');
    s.id = 'posh-buynow-css';
    s.textContent = [
      '.posh-pd__buy{width:100%;min-height:52px;margin-top:10px;display:flex;align-items:center;justify-content:center;gap:8px;border:1.5px solid var(--posh-burgundy,#800020);border-radius:12px;background:#fff;color:var(--posh-burgundy,#800020);font-family:inherit;font-size:16px;font-weight:800;cursor:pointer;transition:background .2s ease,color .2s ease}',
      '.posh-pd__buy:hover{background:var(--posh-burgundy,#800020);color:var(--posh-beige,#f5f5dc)}',
      '.posh-pd__buy:disabled{opacity:.7}',
      '.posh-trustrow{display:flex;flex-wrap:wrap;justify-content:center;gap:6px 14px;margin-top:14px;padding-top:12px;border-top:1px solid rgb(201 164 73/.35)}',
      '.posh-trustrow span{display:inline-flex;align-items:center;gap:5px;font-size:12px;font-weight:700;color:#5b5044;white-space:nowrap}',
      '.posh-trustrow svg{color:#b8962e;flex-shrink:0}',
      '.posh-sticky__buy{flex-shrink:0;min-height:44px;padding:0 16px;border:1.5px solid var(--posh-burgundy,#800020);border-radius:10px;background:#fff;color:var(--posh-burgundy,#800020);font-family:inherit;font-size:14px;font-weight:800;cursor:pointer}',
      '@media (max-width:480px){.posh-sticky__buy{padding:0 12px;font-size:13px}}'
    ].join('');
    document.head.appendChild(s);
  }

  function variantId(form) {
    var el = form.querySelector('input[name="id"]');
    return el && el.value ? Number(el.value) : null;
  }

  function nudgeSize(form) {
    var sizes = form.querySelector('[data-sizes], .posh-pd__sizes, .posh-pd__options');
    if (sizes) {
      sizes.scrollIntoView({ behavior: 'smooth', block: 'center' });
      sizes.classList.add('is-pulse');
      setTimeout(function () { sizes.classList.remove('is-pulse'); }, 1200);
    }
  }

  async function buyNow(form, btn) {
    var id = variantId(form);
    if (!id) { nudgeSize(form); return; }
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = qtyEl ? Math.max(1, parseInt(qtyEl.value, 10) || 1) : 1;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = T.buying;
    try {
      var r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
      });
      if (!r.ok) throw new Error();
      window.location.href = '/checkout';
    } catch (e) {
      btn.disabled = false;
      btn.textContent = label;
    }
  }

  function enhance() {
    var form = document.querySelector('.posh-pd__info form[action*="/cart/add"]');
    if (!form) return;
    injectCss();

    var atc = form.querySelector('[data-atc], .posh-pd__atc');
    if (atc && !form.querySelector('[data-posh-buy]')) {
      var buy = document.createElement('button');
      buy.type = 'button';
      buy.className = 'posh-pd__buy';
      buy.dataset.poshBuy = '1';
      buy.textContent = T.buy;
      buy.addEventListener('click', function () { buyNow(form, buy); });
      atc.insertAdjacentElement('afterend', buy);
    }

    var host = atc ? atc.parentElement : form;
    if (host && !host.querySelector('[data-posh-trust]')) {
      var row = document.createElement('div');
      row.className = 'posh-trustrow';
      row.dataset.poshTrust = '1';
      row.innerHTML = T.trust.map(function (t) {
        return '<span>' + icon(t.icon) + t.text + '</span>';
      }).join('');
      var buyBtn = host.querySelector('[data-posh-buy]');
      (buyBtn || atc || host.lastElementChild).insertAdjacentElement('afterend', row);
    }

    var sticky = document.querySelector('.posh-sticky');
    if (sticky && !sticky.querySelector('[data-posh-sticky-buy]')) {
      var stickyAtc = sticky.querySelector('button, [data-atc]');
      if (stickyAtc) {
        var sb = document.createElement('button');
        sb.type = 'button';
        sb.className = 'posh-sticky__buy';
        sb.dataset.poshStickyBuy = '1';
        sb.textContent = T.buy;
        sb.addEventListener('click', function () { buyNow(form, sb); });
        stickyAtc.insertAdjacentElement('afterend', sb);
      }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance);
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();